import DeviceInfo from '@/modules/util/deviceInfo'
import * as Helper from '@/modules/helper/index'
import {
  Post
} from '@/modules/wrapper/apiWrapper'

export const Register = (gcmKey, SubscriptionId) => {
  if (device.platform === "iOS") {
    console.log('IOS Platform =>>',device.platform)
    // Code for iOS platform
    if (Helper.IsValid(PushNotification)) {
      const push = PushNotification.init({
        android: {
          senderID: gcmKey,
          vibrate: true,
          clearNotifications: true,
          sound: "default",
        },
      ios: {
       gcmSandbox: true,
            alert: "true",
            "sound": true,
            "vibration": true,
        }
      })
      push.on('registration', data => {
        registerOnServerIfRequired(data.registrationId, SubscriptionId)
      })
      push.on('error', error => {
        console.log(error)
      })
      push.on('MessageReceived ', data => {
        console.log('push.on', data)
        // window.localStorage.setItem('Notify'+data.additionalData.notId , data.message)
        if (data.additionalData.NavigationUrl) {
          PushNotification = data
        }
      })
      push.on('notification', data => {
        console.log('push.on', data)
        // window.localStorage.setItem('Notify'+data.additionalData.notId , data.message)
        if (data.additionalData.NavigationUrl) {
          PushNotification = data
        }
      })
      push.finish(function () {
        console.log("notification received successfully");
      })
      return push
    }
    else {

      if (Helper.IsValid(cordova.plugins) && Helper.IsValid(cordova.plugins.firebase)) {
        // Request permission to receive push notifications (required for iOS 16)
        cordova.plugins.firebase.messaging.requestPermission().then((response) => {
          // Get the FCM token
          cordova.plugins.firebase.messaging.getToken().then((token) => {
            // Use the FCM token as needed
            console.log("FCM token: " + token);
          }).catch((error) => {
            console.error("Failed to get FCM token: " + error);
          });
        }).catch((error) => {
          console.error("Failed to request push notification permission: " + error);
        });
        cordova.plugins.firebase.messaging.getToken().then(function (token) {
          console.log("Got device token: ", token)
    registerOnServerIfRequired(token, SubscriptionId)
        });
        cordova.plugins.firebase.messaging.getToken("apns-string").then(function (token) {
       console.log("APNS hex device token: ", token);
        });
        cordova.plugins.firebase.messaging.requestPermission().then(function () {
          console.log("Push messaging is allowed");
        });
        cordova.plugins.firebase.messaging.requestPermission({ forceShow: true }).then(function () {
          console.log("You'll get foreground notifications when a push message arrives");
        });
        cordova.plugins.firebase.messaging.onTokenRefresh(function () {
          console.log("Device token updated");
          registerOnServerIfRequired(token, SubscriptionId)

        });
        cordova.plugins.firebase.messaging.requestPermission({ forceShow: false }).then(function () {
          console.log("Push messaging is allowed");
        });
        console.log('Check Notification =>>>>', window.cordova ,PushNotification)
        const push = PushNotification.init({
          android: {
            senderID: gcmKey,
            vibrate: true,
            clearNotifications: true,
            sound: true,
          },
          browser: {
            pushServiceURL: 'http://push.api.phonegap.com/v1/push'
        },
          ios: {
            gcmSandbox: true,
            alert: "true",
            badge: "true",
            sound: "true"
            // fcmSandbox: true
          }
        })
        push.on('registration', data => {
          registerOnServerIfRequired(data.registrationId, SubscriptionId)
        })
        push.on('error', error => {
          console.log(error)
        })
        push.on('MessageReceived ', data => {
          console.log('push.on', data)
          // window.localStorage.setItem('Notify'+data.additionalData.notId , data.message)
          if (data.additionalData.NavigationUrl) {
            PushNotification = data
          }
        })
        push.on('notification', data => {
            console.log('Notification Recieved', data)
          // do something with the push data
          // then call finish to let the OS know we are done
          push.finish(
            () => {
              console.log('processing of push data is finished');
              navigator.notification.beep();
              navigator.notification.vibrate();
            },
            () => {
              console.log(
                'something went wrong with push.finish for ID =',
                data.additionalData.notId
              );
            },
            data.additionalData.notId
          );
        });
        navigator.notification.beep();
        navigator.notification.vibrate();

    //     push.on('notification', data => {
    // // window.localStorage.setItem('Notify'+data.additionalData.notId , data.message)
    //       if (data.additionalData.NavigationUrl) {
    //         PushNotification = data
    //       }
    //     })
    //     push.finish(function () {
    //       console.log("notification received successfully");
    //     })
        return push
      }
      else {
      }
      //       cordova.plugins.firebase.messaging.onNotification().then( (payload) => {
      //         console.log("messaging data", payload)
      //         let sound = "default";
      //         if (payload.data.sound) {
      //           sound = payload.data.sound;
      //         }
      //         new Notification(payload.notification.title, {
      //           body: payload.notification.body,
      //           sound: sound,
      //         });
      //  })

    }
  } else if (device.platform === "Android") {
    console.log('Device' ,device.platform)
    // Code for Android platform
    if (Helper.IsValid(window.Notification)) {
      const push = window.Notification.init({
        android: {
          senderID: gcmKey,
          vibrate: true,
          clearNotifications: true,
          sound: "default",
        },
        ios: {
          alert: true,
          badge: 0,
          sound: true,
          vibrate: true,
          clearBadge: true,
        }
      })
      push.on('registration', data => {
        registerOnServerIfRequired(data.registrationId, SubscriptionId)
      })
      push.on('error', error => {
        console.log(error)
      })
      push.on('MessageReceived ', data => {
        console.log('push.on', data)
        // window.localStorage.setItem('Notify'+data.additionalData.notId , data.message)
        if (data.additionalData.NavigationUrl) {
          window.NotificationData = data
        }
      })
      push.on('notification', data => {
        console.log('push.on', data)
        // window.localStorage.setItem('Notify'+data.additionalData.notId , data.message)
        if (data.additionalData.NavigationUrl) {
          window.NotificationData = data
        }
      })
      push.finish(function () {
        console.log("notification received successfully");
      })
      return push
    }
    else {
      if (Helper.IsValid(cordova.plugins) && Helper.IsValid(cordova.plugins.firebase)) {
        cordova.plugins.firebase.messaging.getToken().then(function (token) {
          console.log("Got device token: ", token);
          registerOnServerIfRequired(token, SubscriptionId);
        });

        cordova.plugins.firebase.messaging.requestPermission().then(function () {
          console.log("Push messaging is allowed");

          // Listen for incoming messages when the app is in the foreground
          cordova.plugins.firebase.messaging.onMessage(function (payload) {
            console.log('Received push notification:', payload);

            // Handle the notification data here, e.g., show a local notification
          });

          // Handle notifications when the app is in the background or closed
          cordova.plugins.firebase.messaging.onNotificationOpen(function (payload) {
            console.log('Opened push notification:', payload);

            // Handle the notification data here, e.g., navigate to a specific page
            // You can use the payload data to determine where to navigate
          });
        });

        cordova.plugins.firebase.messaging.onTokenRefresh(function () {
          console.log("Device token updated");
          cordova.plugins.firebase.messaging.getToken().then(function (newToken) {
            console.log("Updated device token: ", newToken);
            registerOnServerIfRequired(newToken, SubscriptionId);
          });
        });
      }
      else {
      }
      //       cordova.plugins.firebase.messaging.onNotification().then( (payload) => {
      //         console.log("messaging data", payload)
      //         let sound = "default";
      //         if (payload.data.sound) {
      //           sound = payload.data.sound;
      //         }
      //         new Notification(payload.notification.title, {
      //           body: payload.notification.body,
      //           sound: sound,
      //         });
      //  })

    }
  } else {
    // Code for other platforms
  }
}

const registerOnServerIfRequired = async (data, SubscriptionId) => {
  if (isRequiredToRegisterOnServer(data.registrationId)) {
    const RegistrationID = getRegistrationId()
    let payload = {
      Subscription_Id: SubscriptionId,
      OldDeviceID: RegistrationID,
      NewDeviceID: data,
      AppGUID: Helper.GetAppGUID(SubscriptionId)
    }
    // await AddAppleDeviceId(payload)
    if (!DeviceInfo.isAndroid) {
      await AddAppleDeviceId(payload)
    } else {
      await AddAndroidDeviceId(payload)
    }
    console.log('registerOnServerIfRequired')
    let chatUserId = window.localStorage.getItem('chatUserId' + SubscriptionId)
    if (!Helper.IsNullOrEmpty(chatUserId)) {
      await Post(`ModulesChatsUsers/updateDeviceId/${chatUserId}/${payload.NewDeviceID}`)
    }
    await saveRegistrationId(payload.NewDeviceID)
    await saveFeedBackRegistrationId(payload.NewDeviceID)
  }
}

const isRequiredToRegisterOnServer = (registrationId) => {
  const regId = getRegistrationId()
  const feedId = getFeedBackRegistrationId()
  if (registrationId === regId) {
    return registrationId !== feedId
  }
  return registrationId !== regId
}

const getRegistrationId = () => {
  return window.localStorage.getItem('RegistrationId')
}

const getFeedBackRegistrationId = () => {
  return window.localStorage.getItem('FeedBackRegistrationId')
}

const saveRegistrationId = (RegistrationId) => {
  window.localStorage.setItem('RegistrationId', RegistrationId)
}

const saveFeedBackRegistrationId = (FeedBackRegistrationId) => {
  window.localStorage.setItem('FeedBackRegistrationId', FeedBackRegistrationId)
}

const AddAndroidDeviceId = (AndroidParam) => {
  return Post('SubscriptionsRegisteredDevicesGoogle', AndroidParam)
    .then(response => {
      console.log('PushNotification An Success: ', response)
    }, response => {
      console.log('PushNotification An error: ', response)
    })
}

const AddAppleDeviceId = (AppleParam) => {
  return Post('SubscriptionsRegisteredDevicesApple', AppleParam)
    .then(response => {
      console.log('PushNotification Ap Success: ', response)
    }, response => {
      console.log('PushNotification Ap error: ', response)
    })
}




// WEBPACK FOOTER //
// ./src/modules/notification/index.js